<template>
  <div>
    <v-card style="display: contents">
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          style="
            font-size: 18px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
            cursor: default;
            margin-top: -1rem;
          "
        ></div>
        <v-card-text>
          <div>
            <v-row justify="center" class="page-header mt-6">
              <v-col
                cols="12"
                md="8"
                class="d-flex align-center justify-center header-container"
              >
                <v-icon
                  @click="BackToMain"
                  size="38"
                  class="back-icon mr-3"
                  color="#14223c"
                >
                  mdi-arrow-left-bold-circle-outline
                </v-icon>

                <span class="header-title">{{
                  $t("message.ParkingInformation")
                }}</span>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" md="8" class="mx-auto px-4">
                <v-tabs>
                  <v-tab @click="ChangeTab('Information')">{{
                    $t("message.Information")
                  }}</v-tab>
                  <v-tab @click="ChangeTab('History')">{{
                    $t("message.RedemptionHistory")
                  }}</v-tab>
                  <v-tabs-slider :color="ColorTab"></v-tabs-slider>
                  <v-tab-item>
                    <v-card flat class="mt-2">
                      <v-card-text>
                        <v-card>
                          <table
                            style="
                              width: 100%;
                              font-size: 16px;
                              border-collapse: collapse;
                            "
                          >
                            <tbody>
                              <br />
                              <tr>
                                <td
                                  style="
                                    width: 50%;
                                    color: #14223c;
                                    padding-left: 1rem;
                                    font-weight: bold;
                                  "
                                >
                                  {{ $t("message.TicketNo") }}
                                </td>
                                <td
                                  style="
                                    width: 50%;
                                    text-align: right;
                                    color: #14223c;
                                    padding-right: 1rem;
                                  "
                                >
                                  {{ TicketNo }}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    color: #14223c;
                                    padding-left: 1rem;
                                    font-weight: bold;
                                  "
                                >
                                  {{ $t("message.DateTime") }}
                                </td>
                                <td
                                  style="
                                    text-align: right;
                                    color: #14223c;
                                    padding-right: 1rem;
                                  "
                                >
                                  {{ DateTime }}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    color: #14223c;
                                    padding-left: 1rem;
                                    font-weight: bold;
                                  "
                                >
                                  {{ $t("message.TimeIn") }}
                                </td>
                                <td
                                  style="
                                    text-align: right;
                                    color: #14223c;
                                    padding-right: 1rem;
                                  "
                                >
                                  {{ TimeIn }}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    color: #14223c;
                                    padding-left: 1rem;
                                    font-weight: bold;
                                  "
                                >
                                  {{ $t("message.Duration") }}
                                </td>
                                <td
                                  style="
                                    text-align: right;
                                    color: #14223c;
                                    padding-right: 1rem;
                                  "
                                >
                                  {{ numberWithCommas(Duration) }}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    color: #14223c;
                                    padding-left: 1rem;
                                    font-weight: bold;
                                  "
                                >
                                  {{ $t("message.CarLicense") }}
                                </td>
                                <td
                                  style="
                                    text-align: right;
                                    color: #14223c;
                                    padding-right: 1rem;
                                  "
                                >
                                  {{ CarLicense }}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    color: #14223c;
                                    padding-left: 1rem;
                                    font-weight: bold;
                                  "
                                >
                                  {{ $t("message.VehicleName") }}
                                </td>
                                <td
                                  style="
                                    text-align: right;
                                    color: #14223c;
                                    padding-right: 1rem;
                                  "
                                >
                                  {{ VehicleName }}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    color: #14223c;
                                    padding-left: 1rem;
                                    font-weight: bold;
                                  "
                                >
                                  {{ $t("message.RateDetail") }}
                                </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td
                                  style="
                                    text-align: right;
                                    color: #de7302;
                                    padding-right: 1rem;
                                  "
                                >
                                  {{
                                    $t("message.RateDetailLang") == "ENG"
                                      ? RateDetailENG.split("\r\n")[0]
                                      : RateDetail.split("\r\n")[0]
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td colspan="2" style="height: 10px"></td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    color: #14223c;
                                    padding-left: 1rem;
                                    font-weight: bold;
                                  "
                                >
                                  {{ $t("message.Total") }}
                                </td>
                                <td
                                  style="
                                    text-align: right;
                                    color: green;
                                    font-size: 20px;
                                    padding-right: 1rem;
                                  "
                                >
                                  {{ numberWithCommas(Total) }}
                                  <span
                                    style="
                                      color: black;
                                      font-size: 16px;
                                      font-weight: bold;
                                    "
                                  >
                                    {{ $t("message.Baht") }}
                                  </span>
                                </td>
                              </tr>
                              <br />
                            </tbody>
                          </table>
                        </v-card>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat class="mt-2">
                      <v-card-text>
                        <v-data-table
                          :headers="headersHistory"
                          :items="HistoryList"
                          :items-per-page="5"
                          :mobile-breakpoint="0"
                          single-line
                          hide-details
                          :disable-sort="true"
                        >
                          <template v-slot:item="{ item }">
                            <tr>
                              <td>{{ item.rateCode }}</td>
                              <td>{{ item.detail }}</td>
                              <td>{{ ChangeFormatDate(item.stampTime) }}</td>
                              <td>{{ item.stampBy }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-col>
            </v-row>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="5">
                <div @click="ClearRate()">
                  <p style="font-size: 16px; font-weight: bold">
                    {{ $t("message.RateDetail") }}
                  </p>
                  <v-radio-group
                    v-model="RateData"
                    style="margin-left: auto; margin-right: auto"
                  >
                    <v-card
                      v-for="(item, index) in RateList"
                      :key="index"
                      class="mb-2"
                      style="background-color: #e3ecf7; padding: 0.5rem 1rem"
                    >
                      <v-radio
                        :value="item.rateCode"
                        hide-details
                        class="pa-0"
                        style="width: 100%"
                      >
                        <template #label>
                          <span v-if="item.limitStatus" style="color: green">
                            {{ item.rateDetail }} (คงเหลือ
                            <span style="color: red">{{
                              item.limitQuotaRemain
                            }}</span>
                            จาก {{ item.limitQuota }} ครั้ง)
                          </span>
                          <span v-else style="color: green">
                            {{ item.rateDetail }}
                          </span>
                        </template>
                      </v-radio>
                    </v-card>
                  </v-radio-group>
                </div>
              </v-col>
            </v-row>
            <!-- <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="2">
                <p style="font-size: 16px; font-weight: bold">Ref Code</p>
                <v-text-field v-model="RefLog" outlined dense></v-text-field>
              </v-col>
            </v-row> -->
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="6">
                <p style="font-size: 16px; font-weight: bold">
                  {{ $t("message.Remark") }}
                </p>
                <v-textarea v-model="Remark" outlined></v-textarea>
              </v-col>
            </v-row>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="4" align="center">
                <v-btn
                  v-if="RedeemButtonStatus == false"
                  height="40"
                  width="130"
                  outlined
                  color="indigo"
                  @click="RedeemData()"
                >
                  {{ $t("message.EStamp") }}
                </v-btn>
                <v-btn
                  v-else
                  disabled
                  height="40"
                  width="130"
                  outlined
                  color="indigo"
                  @click="RedeemData()"
                >
                  {{ $t("message.EStamp") }}
                </v-btn>
                <v-btn
                  height="40"
                  width="130"
                  class="mx-1"
                  outlined
                  color="red"
                  @click="CancelRedeem()"
                >
                  {{ $t("message.Cancel") }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12"></v-col>
            </v-row>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="LoadingDialog" persistent width="0.01">
      <v-card>
        <v-card-text>
          <v-row>
            <LoadingComponent class="centered"></LoadingComponent>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "ParkingInformation",
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",
      id: null,
      response: "",
      RedemptionType: null,
      TenantID: null,
      LogID: null,
      TerminalID: null,
      DatetimeIn: "",
      MemberType: null,
      CarType: null,
      UserID: null,

      TicketNo: "",
      DateTime: "",
      TimeIn: "",
      Duration: "",
      exempt: "",
      summaryDuration: "",
      CarLicense: "",
      VehicleName: "",
      RateCodeString: "",
      RateDetail: "",
      RateDetailENG: "",
      Total: "",
      SpendingValue: "",
      RateList: [],
      RateData: null,
      OldRateData: null,
      Remark: "",
      ColorTab: "#126496",
      ColorText: "#126496",
      Status: false,
      tab: null,
      HistoryList: [],

      QRCodeData: "",
      idqr: null,
      POSValue: "",
      TempPOSValue: "",
      ScannerDialog: false,
      ScannerList: [],
      TempScannerList: [],
      TotalAmountPOS: 0,
      UsagePOSValue: 0,

      TempSNScanDetail: "",
      TempAmountScanDetail: "",

      StatusReader: false,
      AddPOSButtonStatus: false,
      RedeemButtonStatus: false,

      CouponValue: "",
      TempCPNo: "",
      TempCPAmount: "",
      TempCouponValue: "",
      TotalCouponAmount: null,
      UsageCouponValue: 0,
      ResponseQRTigerText: "",
      ResponseData: [],
      RefLog: "",
    };
  },
  computed: {
    headersHistory() {
      return [
        {
          text: "RateCode",
          align: "left",
        },
        {
          text: "Detail",
          align: "left",
        },
        {
          text: "StampTime",
          align: "left",
        },
        {
          text: "StampBy",
          align: "left",
        },
      ];
    },
  },

  async mounted() {
    let self = this;
    self.response = self.$route.params.response;
    if (self.response.length > 0) {
      self.LogID = self.$route.params.response[0].logId;
      self.TenantID = parseInt(localStorage.getItem("TenantID"));
    }
    self.BindingDataResponse();
    // await self.GetDataRedemptionHistoryByLogId();
  },

  methods: {
    ClearRate() {
      let that = this;
      if (that.OldRateData == that.RateData) {
        that.RateData = null;
      }
      that.OldRateData = that.RateData;
    },

    ChangeTab(value) {
      let self = this;
      if (value == "Information") {
        self.ColorTab = "#126496";
        self.ColorText = "#126496";
        self.Status = false;
      } else {
        self.GetDataRedemptionHistoryByLogId();
        self.ColorTab = "#126496";
        self.Status = true;
      }
    },

    GetDataRedemptionHistoryByLogId() {
      let self = this;
      let temp = {
        LogCarparkID: self.LogID,
      };
      axios
        .post(`${self.url}Redemption/GetDataRedemptionHistoryByLogId`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.HistoryList = response.data.data;
          }
        })
        .catch(function (error) {
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: message,
          });
        });
    },

    BackToMain() {
      let self = this;
      self.$router.push({ name: "Main" });
    },

    async GetDataRateCode(membertype, vehicletype) {
      let self = this;
      let temp = {
        MemberType: membertype,
        VehicleType: vehicletype,
      };
      await axios
        .post(`${self.url}Redemption/GetDataRateCode`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.RateList = response.data.data;
          }
        })
        .catch(function (error) {
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: message,
          });
          self.BackToMain();
        });
    },

    CancelRedeem() {
      let self = this;
      self.$router.push({ name: "Main" });
    },

    async BindingDataResponse() {
      let self = this;
      // console.log(self.response);
      if (self.response != "" && self.response != undefined) {
        if (self.response.length > 0 && self.response[0].status != "Fail") {
          self.ResponseData = self.response[0];
          self.TerminalID = self.response[0].terminalInId;
          self.DatetimeIn = self.response[0].entryDateTime;
          self.MemberType = self.response[0].memberTypeId;
          self.CarType = self.response[0].vehicleTypeId;
          self.TicketNo = self.response[0].ticketNo;
          self.DateTime = new Date(
            self.response[0].entryDateTime
          ).toLocaleDateString("en-us", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });
          self.TimeIn =
            self.response[0].entryDateTime.split(" ").length > 0
              ? self.response[0].entryDateTime.split(" ")[1]
              : "";
          self.Duration =
            self.response[0].parkHH +
            " hrs " +
            self.response[0].parkMM +
            " mins";
          self.exempt =
            self.response[0].redeemHourDisplay +
            " hrs " +
            self.response[0].redeemMinuteDisplay +
            " mins";
          self.summaryDuration =
            self.response[0].parkHHDisplay +
            " hrs " +
            self.response[0].parkMMDisplay +
            " mins";
          self.CarLicense = self.response[0].plateNo;
          self.VehicleName = self.response[0].vehicleTypeName;
          self.RateCodeString = self.response[0].rateCode;
          self.RateDetail = self.response[0].rateDetailTH;
          self.RateDetailENG = self.response[0].rateDetailEN;
          self.Total = self.response[0].total;
          await this.GetDataRateCode(
            self.response[0].memberTypeId,
            self.response[0].vehicleTypeId
          );
        } else {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: self.response[0].message,
          });
        }
      } else {
        self.BackToMain();
      }
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    RedeemData() {
      let self = this;
      if (
        self.LogID == "" ||
        self.TerminalID == null ||
        self.DatetimeIn == "" ||
        self.TicketNo == "" ||
        self.CarLicense == "" ||
        self.MemberType == null ||
        self.CarType == null ||
        self.TenantID == null ||
        self.RateData == null
      ) {
        Swal.fire({
          icon: "warning",
          width: 600,
          text: "กรุณากรอกข้อมูลให้ครบถ้วน!",
        });
      } else {
        self.RedeemButtonStatus = true;
        self.LoadingDialog = true;
        let temp = {
          LogCarparkID: self.LogID,
          TerminalID: self.TerminalID,
          DatetimeIn: self.DatetimeIn,
          RunningNumber: self.TicketNo,
          PlateNumber: self.CarLicense,
          MemberType: self.MemberType,
          CarType: self.CarType,
          TenantID: self.TenantID,
          RateCode: self.RateData,
          Remark: self.Remark,
          RefLog: self.RefLog,
        };

        axios
          .post(`${self.url}Redemption/RedeemParking`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.RedeemButtonStatus = false;
              self.$router.push({
                name: "Redemption",
                params: {
                  ResponseRedeem: response.data.data,
                  ratecode:
                    self.RateData == null
                      ? response.data.data
                      : self.RateList.filter(
                          (x) => x.rateCode == self.RateData
                        )[0].rateDetail,
                },
              });
            }
          })
          .catch(function (error) {
            self.RedeemButtonStatus = false;
            let message = "เกิดข้อผิดพลาด";
            if (error.response && error.response.data) {
              message = error.response.data.message || message;
            }
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      }
    },

    ChangeFormatDate(date) {
      if (!date) return null;

      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
  },
};
</script>
<style scoped>
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
.TitleCSS {
  font-size: 18px;
  font-weight: 300;
}
@font-face {
  font-family: "English";
  src: local("English"), url(../assets/Font/Kanit-Regular.ttf);
}
* >>> .v-data-table-header {
  background-color: #333333;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

* >>> .v-data-table-header-mobile {
  display: none;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/* * >>> .v-label {
  color: green;
  justify-content: center;
} */
.box-info {
  border: 1px solid black;
  will-change: transform;
  transform: translateZ(0);
}
.page-header {
  width: 100%;
}

.header-container {
  background: #8fb5ea;
  border-radius: 12px;
  padding: 0.8rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.header-container:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
}

.back-icon {
  cursor: pointer;
  transition: 0.25s ease;
}

.back-icon:hover {
  transform: scale(1.1);
  color: #1e3a8a !important;
}

.header-title {
  font-size: 24px;
  font-weight: 600;
  color: #14223c;
  letter-spacing: 0.5px;
}

@media (max-width: 960px) {
  .header-title {
    font-size: 20px;
  }
  .header-container {
    padding: 0.6rem 1rem;
  }
}

@media (max-width: 600px) {
  .header-title {
    font-size: 18px;
  }
  .header-container {
    padding: 0.5rem 0.8rem;
  }
}
</style>
